import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import * as Pikaday from 'pikaday';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
//import * as moment from 'moment';
import * as dayjs from 'dayjs';
//import * as moment from 'moment';


@Component({
	selector: 'app-date-picker',
	templateUrl: './date-picker.component.html',
	styleUrls: ['./date-picker.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DatePickerComponent),
			multi: true,
		},
	],
})
export class DatePickerComponent {
	picker: Pikaday;
	disabled: boolean;
	_value: string;

	@ViewChild('pikaday', { static: true }) el: ElementRef;

	@Input()
	isDisabled: Boolean = false;

	@Input()
	placeholder: string;

	@Input()
	title: string;

	@Input()
	isRequired: boolean;

	@Input()
	isHorizontalLayout: boolean;

	constructor() {
		this.title = '&nbsp;';
		this.isHorizontalLayout = false;
	}

	onChanged: any = () => {};
	onTouched: any = () => {};

	showPicker() {
		if (!this.picker.isVisible()) {
			this.picker.show();
		}
	}

	writeValue(val) {
		this._value = val;
		const self = this;
		if (!this.picker) {
			this.picker = new Pikaday({
				defaultDate: this._value ? new Date(this._value) : null,
				setDefaultDate: true,
				yearRange: [new Date().getFullYear() - 3, new Date().getFullYear() + 200],
				field: this.el.nativeElement,
				format: 'MM/DD/YYYY',
				onSelect: function (newDate) {
					self._value = dayjs(newDate).format();
					self.onChanged(self._value);
					self.onTouched();
				},
			});
		}
	}

	registerOnChange(fn: any) {
		this.onChanged = fn;
	}
	registerOnTouched(fn: any) {
		this.onTouched = fn;
	}
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	updateValue(value) {
		if (value.target && value.target.value === '') {
			this._value = '';
			this.onChanged('');
			this.onTouched();
		}
	}
}
